import { getEmbedViewport } from "./embedViewport";

// With the embed script on a phone, the page around the iframe shows the
// booking bar as its own fixed element, which stays at the bottom of the
// screen without delay. The app sends the texts and gets the taps.

const BAR_MESSAGE = "rentalls-sticky-bar";
const ACTION_MESSAGE = "rentalls-sticky-bar-action";

let lastSent = null;

export const parentShowsBookingBar = () => getEmbedViewport()?.bar === true;

export const sendBookingBar = (state, win = window) => {
  if (win.parent === win || !parentShowsBookingBar()) return false;
  const message = { type: BAR_MESSAGE, ...state };
  const key = JSON.stringify(message);
  if (key !== lastSent) {
    lastSent = key;
    win.parent.postMessage(message, "*");
  }

  return true;
};

export const onBookingBarAction = (callback, win = window) => {
  const handler = (event) => {
    if (event.source === win.parent && event.data?.type === ACTION_MESSAGE) callback();
  };
  win.addEventListener("message", handler);

  return () => win.removeEventListener("message", handler);
};

// For tests.
export const resetBookingBar = () => {
  lastSent = null;
};
